import React, { useEffect, useState } from "react";
import { onSessionExpired } from "./sessionExpired";

export default function SessionExpiredModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => onSessionExpired(() => setOpen(true)), []);

  if (!open) return null;

  const handleLogin = () => {
    try {
      localStorage.removeItem("token");
    } catch (_) {}
    const from = window.location.pathname + window.location.search;
    window.location.href = `/login?from=${encodeURIComponent(from)}`;
  };

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-white rounded-xl shadow-2xl p-6 max-w-sm w-[90%] mx-4 animate-in fade-in zoom-in duration-150">
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          Sesión caducada
        </h2>
        <p className="text-sm text-gray-600 mb-5">
          Por motivos de seguridad, tu sesión ha expirado. Vuelve a iniciar
          sesión para continuar.
        </p>
        <button
          onClick={handleLogin}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2.5 rounded-lg transition-colors"
        >
          Iniciar sesión
        </button>
      </div>
    </div>
  );
}
